
import React, { useEffect, useRef, useState } from "react";
import "./gallery.css"
import imgs from "../renderImgs";

export default function Gallery() {
  const galleryRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  let isScrooling = useRef(false);
  
  useEffect(() => {
    const obj = galleryRef.current
    
      const onWheel = (e) => {
        e.preventDefault()  
    
        if (isScrooling.current) return
    
        isScrooling.current = true
        
        const multiplier = 4;
    
        galleryRef.current.scrollBy({ 
          left: e.deltaY * multiplier, 
          behavior: 'auto' });
    
        setTimeout(() => {
          isScrooling.current = false
        },250)
      };

    if(!obj) return;

    obj.addEventListener('wheel', onWheel,{passive: false})
    
    return (() => {
      obj.removeEventListener('wheel',onWheel)
    })
  },[])

  useEffect(() => {
    const handleScroll = () => {
      const container = galleryRef.current;
      const images = container.querySelectorAll("img");
      const centerX = window.innerWidth / 2;

      let closest = { index: 0, distance: Infinity };

      images.forEach((img, index) => {
        const rect = img.getBoundingClientRect();
        const imgCenter = rect.left + rect.width / 2;
        const distance = Math.abs(centerX - imgCenter);

        if (distance < closest.distance) {
          closest = { index, distance };
        }
      });

      setActiveIndex(closest.index);
    };

    const obj = galleryRef.current;
    obj.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    handleScroll();

    return () => {
      obj.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  return (
    <div className="gallery-container" ref={galleryRef}>
      <div className="gallery">
        {imgs.map((photo, index) => (
          <img
            key={index}
            src={photo}
            className={`gallery-img ${index === activeIndex ? "active" : ""}`}
            alt={`img-${index}`}
          />
        ))}
      </div>
    </div>
  );
}

